import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Icons from 'consts/icons';

import { makeStyles } from '@material-ui/core/styles';
import { Tooltip } from '@material-ui/core';

const useStyles = makeStyles({
  ArrowBack: {
    cursor: 'pointer',
    position: 'absolute',
  },
  ArrowBackCalc: {
    left: props => props.fromLeft,
    top: props => props.fromTop,
  },
});

const ArrowBack = props => {
  const useString = () => {
    const language = useSelector(state => state.language);
    return language;
  };
  const classes = useStyles(props);
  const { clickFunction } = props;
  const title = useString().back_;

  return (
    <Tooltip title={title} placement="right">
      <Icons.Navigation.ArrowBack
        className={`${classes.ArrowBack} ${classes.ArrowBackCalc}`}
        onClick={clickFunction}
      />
    </Tooltip>
  );
};

ArrowBack.propTypes = {
  clickFunction: PropTypes.func.isRequired,
};

export default ArrowBack;
